/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuPriceRanges_itemSearch$ref = any;
export type SbSharedRefineMenuPriceRanges_itemSearch = {
    readonly displayUriRef: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly filters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly linkReference: string | null;
            readonly linkable: boolean | null;
            readonly displayName: string | null;
            readonly urlLabel: string | null;
            readonly currency: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": SbSharedRefineMenuPriceRanges_itemSearch$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "urlLabel",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SbSharedRefineMenuPriceRanges_itemSearch",
        "type": "ItemSearchQueryConnection",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayUriRef",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "appliedFilters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canBeDismissed",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "plural": true,
                        "selections": [
                            (v1 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "filters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseFilter",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "linkReference",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "linkable",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "displayName",
                                "args": null,
                                "storageKey": null
                            },
                            (v1 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "currency",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '11d711fa50bc0fc95468c9acd7bc7743';
export default node;
